import React from "react";
import DrawerTitle from "src/Components/Drawer/DrawerTitle";
import GoogleMapComponent from "src/Components/GlobalComponents/GoogleMapComponent";
import { AllTabType, IAddressData } from "src/types/GlobalInterfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import { setCurrentAddress } from "src/Store/cartSlice";

interface IProps {
  setActiveTab?: (tab: AllTabType) => void;
  onBack?: () => void;
  setPickAddress?: (address: any) => void;
}

const AddNewAddressSection = ({
  setActiveTab,
  onBack,
  setPickAddress,
}: IProps) => {
  const { isLogged } = useSelector((state: RootState) => state.appReducer);
  const dispatch = useDispatch();
  return (
    <>
      <DrawerTitle title="Select Location" onBack={onBack} backBtn />
      <div className="w-full flex flex-col gap-2 pt-2">
        <GoogleMapComponent
          className="w-full"
          mapContainerClass="max-h-auto min-h-fit"
          btnContainerClass="!fixed bottom-0 left-0 bg-drawer px-2 2xl:px-3 py-[2px] 2xl:py-1 shadow-all"
          onConfirm={(address) => {
            console.log("Address Select By Users ===> ", address);
            if (isLogged) {
              setPickAddress?.(address);
            } else {
              dispatch(setCurrentAddress(address?.fullAddress || ""));
              onBack?.();
            }
          }}
          containerStyle={{
            height: "calc(100vh - 150px)",
            borderRadius: "0px",
            border: "none",
          }}
          confirmBtnId="google-map-confirm-btn"
        />
      </div>
    </>
  );
};

export default AddNewAddressSection;
